import React, { useEffect } from 'react';
import Hero from '../components/home/Hero';
import ProjectGrid from '../components/home/ProjectGrid';
import Contact from '../components/Contact';

const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = 'AI4U — GENAI Technologies';
  }, []);

  return (
    <main>
      <Hero />
      <ProjectGrid />
      <Contact />
    </main>
  );
};

export default HomePage;
